module.exports = __webpack_public_path__ + "static/media/gold_logo.2f37ceff.svg";